import { render, staticRenderFns } from "./parent.vue?vue&type=template&id=02cb91b8&"
import script from "./parent.vue?vue&type=script&lang=ts&"
export * from "./parent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports